<template>
  <div class="group-box">
    <slot />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.group-box {
  padding: 16px;
  border: 1px solid #CBD5E1;
  border-radius: 8px;
  box-shadow: 0px 1px 2px 0px #0000000F, 0px 1px 3px 0px #0000001A;
}
</style>
